import React from "react";
import { FaRedoAlt, FaShieldAlt, FaSlidersH } from "react-icons/fa";

export default function TechniquesQuizzSettingsCard({
  ui,
  dynamicOptions,
  loading,
  totalTechniques,
  onChange,
  onRestart,
}) {
  const fieldClass =
    "w-full rounded-2xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none transition focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-white dark:focus:ring-indigo-900/30";

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Paramètres du quizz
            </p>

            <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
              Choisir le niveau d’entraînement
            </h2>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Changez la ceinture, le nombre de questions ou l’inclusion de la
              self-défense. Un nouveau quizz sera généré automatiquement.
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm dark:border-slate-700 dark:bg-slate-800/60">
            <span className="text-slate-500 dark:text-slate-400">
              Base :
            </span>{" "}
            <span className="font-bold text-slate-900 dark:text-white">
              {loading ? "…" : totalTechniques}
            </span>
            <span className="text-slate-500 dark:text-slate-400">
              {" "}
              techniques
            </span>
          </div>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-3 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Ceinture
            </label>

            <select
              value={ui.grade}
              onChange={(event) => onChange({ grade: event.target.value })}
              disabled={loading}
              className={fieldClass}
            >
              {dynamicOptions.grades.map((grade) => (
                <option key={grade} value={grade}>
                  {grade}
                </option>
              ))}
            </select>
          </div>

          <div className="lg:col-span-3">
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Nombre de questions
            </label>

            <select
              value={ui.count}
              onChange={(event) => onChange({ count: Number(event.target.value) })}
              disabled={loading}
              className={fieldClass}
            >
              {dynamicOptions.counts.map((count) => (
                <option key={count} value={count}>
                  {count} questions
                </option>
              ))}
            </select>
          </div>

          <div className="lg:col-span-3">
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Self-défense
            </label>

            <button
              type="button"
              onClick={() =>
                onChange({ includeSelfDefense: !ui.includeSelfDefense })
              }
              disabled={loading}
              className={`flex min-h-[46px] w-full items-center justify-between gap-3 rounded-2xl px-4 text-sm font-bold ring-1 transition disabled:opacity-60 ${
                ui.includeSelfDefense
                  ? "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-200 dark:ring-emerald-800/60"
                  : "bg-slate-50 text-slate-700 ring-slate-200 hover:bg-slate-100 dark:bg-slate-800/60 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-800"
              }`}
            >
              <span className="inline-flex items-center gap-2">
                <FaShieldAlt />
                {ui.includeSelfDefense ? "Incluse" : "Exclue"}
              </span>

              <span
                className={`relative inline-flex h-6 w-11 rounded-full transition ${
                  ui.includeSelfDefense
                    ? "bg-emerald-500"
                    : "bg-slate-300 dark:bg-slate-700"
                }`}
              >
                <span
                  className={`absolute top-1 h-4 w-4 rounded-full bg-white shadow transition ${
                    ui.includeSelfDefense ? "left-6" : "left-1"
                  }`}
                />
              </span>
            </button>
          </div>

          <div className="lg:col-span-2">
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Action
            </label>

            <button
              type="button"
              onClick={onRestart}
              disabled={loading}
              className="inline-flex min-h-[46px] w-full items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-4 text-sm font-bold text-white transition hover:bg-indigo-800 disabled:opacity-60"
            >
              <FaRedoAlt />
              Nouveau
            </button>
          </div>
        </div>

        <div className="mt-4 inline-flex items-center gap-2 rounded-2xl bg-slate-50 px-4 py-3 text-xs font-bold text-slate-500 ring-1 ring-slate-200 dark:bg-slate-800/60 dark:text-slate-300 dark:ring-slate-700">
          <FaSlidersH />
          Les options régénèrent automatiquement les questions.
        </div>
      </div>
    </section>
  );
}